'use client';

import { Stack } from '@mui/material';
import type { ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

export default function ActionButtonGroup({ children }: Props) {
  return (
    <Stack
      direction="row"
      className="ActionButtonsGroup"
      sx={{
        alignItems: 'center',
        gap: 1,
      }}
    >
      {children}
    </Stack>
  );
}
